import * as React from "react";
import { useAuth } from "../Services/AuthContext";
import { Modal as ModalStrap } from 'reactstrap';
import LoginPanel from "./Pages/LoginPanels/LoginPanel";
import IndicativePrice from './Pages/LoginPanels/IndicativePrice';
import ForgotPasswordPanel from "./Pages/LoginPanels/ForgotPasswordPanel";
import NewAccount from "./Pages/LoginPanels/NewAccount";

import TermsPanel from "./Pages/LoginPanels/TermsPanel";

const Login = () => {
    const [forgotPassword, setForgotPassword] = React.useState(false);
    const [newAccount, setNewAccount] = React.useState(false);
    const [indicitavePrice, setIndicitavePrice] = React.useState(false);
    const [bigger, setBigger] = React.useState(true);
    const [authUser] = useAuth();
    const s = authUser.jwt && authUser.terms ? null : { width: '100vw', height: '100vh', backgroundImage: "url(/img/Light-Jet.jpg)" };
    const openModal = (!authUser.jwt || !authUser.terms) && (!forgotPassword && !indicitavePrice && !newAccount);
    return <div style={s}>
        <ModalStrap contentClassName="transparentmodal" fade={false} size={bigger || indicitavePrice ? "lg" : "md"} style={{ marginTop: '100px'}} isOpen={forgotPassword || indicitavePrice || newAccount}  >
            {forgotPassword ? <ForgotPasswordPanel onClose={() => setForgotPassword(false)} /> : null}
            {indicitavePrice ? <IndicativePrice onBigger={setBigger} onClose={() => setIndicitavePrice(false)} /> : null}
            {newAccount ? <NewAccount onBigger={setBigger} onClose={() => setNewAccount(false)} /> : null}
        </ModalStrap>
        {openModal ? <ModalStrap isOpen={true} fade={false} size={authUser.jwt ? "lg" : "md"} contentClassName="transparentmodal" centered>
            {!authUser.jwt ? <LoginPanel setForgotPassword={setForgotPassword} setNewAccount={setNewAccount} setIndicitavePrice={setIndicitavePrice} /> :
                <TermsPanel />}
        </ModalStrap> : null}
    </div>
}

export default Login;